import { OktaAuth } from '@okta/okta-auth-js'

// Org authorization server (not a custom AS). Access tokens can't carry custom
// claims on an org AS, so we use the ID token (with a per-app groups claim
// filter) for both UI gating and as the bearer to our backend.
const issuer = process.env.REACT_APP_OKTA_ISSUER || 'https://barrys.okta.com'
const clientId = process.env.REACT_APP_OKTA_CLIENT_ID || ''

if (!clientId) {
  // Surfaced in the browser console during local dev if env is missing.
  console.error('REACT_APP_OKTA_CLIENT_ID is not set — Okta login will fail.')
}

export const oktaAuth = new OktaAuth({
  issuer,
  clientId,
  // Computed from the current origin so the same build works on localhost,
  // the herokuapp.com URL, and admin-international.barrys.com.
  redirectUri: `${window.location.origin}/login/callback`,
  postLogoutRedirectUri: window.location.origin,
  scopes: ['openid', 'profile', 'email', 'groups'],
  pkce: true,
  // Re-acquire tokens silently before they expire.
  tokenManager: { autoRenew: true },
})

/** The Okta ID token string, or null if not authenticated. */
export function getIdToken(): string | null {
  return oktaAuth.getIdToken() || null
}
